import { connect } from "react-redux";
import loadergif from "../../../assets/gif/loadergif.gif";
import ResizeListener from "../../../utility/ResizeListener";
import "../customLoader/loader.css";
const CustomLoader = ({ size = 40, isLoading }) => {
  const { width, height } = ResizeListener();

  return (
    <>
      {isLoading && (
        <div
          style={{
            width,
            height: height,
            backgroundColor: "rgba(96,96,96,0.3)",
            position: "absolute",
            zIndex: 100,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={loadergif}
            style={{
              width: 300,
              height: 300,
              objectFit: "contain",
            }}
            alt="loader-gif"
          />
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    isLoading: state.fullScreenLoadingReducer.isLoading,
  };
};
export default connect(mapStateToProps)(CustomLoader);
